/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContest = {

	delete (context, contestId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteDacCodes (context, codeId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest/dac-codes"
			+ "?codeId=" + codeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteForm (context, contestId, agencyContestFormType, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest/form"
			+ "?contestId=" + contestId
			+ "&agencyContestFormType=" + agencyContestFormType
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteProjectType (context, contestId, projectTypeId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest/project-type"
			+ "?contestId=" + contestId
			+ "&projectTypeId=" + projectTypeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteRatingParameter (context, contestId, paramId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest/rating-parameter"
			+ "?contestId=" + contestId
			+ "&paramId=" + paramId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteUser (context, contestUserId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-contest/user"
			+ "?contestUserId=" + contestUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyEvaluationConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/agency-evaluation-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyFinalReportConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/agency-final-report-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyMonitoringConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/agency-monitoring-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAgencyProjectConstantFields (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/agency-project-constant-fields"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/all-contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllForms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/all-forms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/contest-configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestName (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/contest-name"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestTerms (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/contest-terms"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodes (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/dac-codes"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodesAvailableToAdd (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/dac-codes-available-to-add"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDacCodesStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/dac-codes/status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getData (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/data"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExport (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/data-required-to-export"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportEvaluations (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/data-required-to-export-evaluations"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportFinalReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/data-required-to-export-final-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDataRequiredToExportMonitoringReports (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/data-required-to-export-monitoring-reports"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDepartmentContests (context, departmentId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/department-contests"
			+ "?departmentId=" + departmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getEvaluationFormsInclusionStatus (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/evaluation-forms-inclusion-status"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getExpertEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/expert-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getExperts (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/experts"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/final-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFinalReportNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/final-report-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getForm (context, contestId, genericFormType, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/form"
			+ "?contestId=" + contestId
			+ "&genericFormType=" + genericFormType
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIndividualEvaluationNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/individual-evaluation-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getIsSubstantiveOrFinalEvaluationPresent (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/is-substantive-or-final-evaluation-present"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMonitoringReportNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/monitoring-report-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getOfferNames (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/offer-names"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPanelInfo (context, id, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/panel-info"
			+ "?id=" + id
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/project-configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectTypes (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/project-types"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getRatingParameters (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/rating-parameters"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getRatingSettings (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/rating-settings"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getState (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/state"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserRole (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/user-role"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsers (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/users"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsersAvailableToAdd (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest/users-available-to-add"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, contestDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest"
			, contestDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCloseEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/close-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postDacCodes (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/dac-codes"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postEvaluationsExport (context, contestId, exportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/evaluations-export"
			+ "?contestId=" + contestId
			, exportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postFinishEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/finish-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postForm (context, loadSchemaDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/form"
			, loadSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postOpenEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/open-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postProjectExport (context, contestId, offerExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/project-export"
			+ "?contestId=" + contestId
			, offerExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postProjectType (context, contestId, projectTypeId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/project-type"
			+ "?contestId=" + contestId
			+ "&projectTypeId=" + projectTypeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRatingParameter (context, param, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/rating-parameter"
			, param
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postUndoFinishEvaluation (context, contestId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/undo-finish-evaluation"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postUserContestRole (context, contestUserId, newRole, onSuccess, onError, options) {
		Api.post(context,
			"/agency-contest/user-contest-role"
			+ "?contestUserId=" + contestUserId
			+ "&newRole=" + newRole
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putClose (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/close"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDacCodes (context, contestId, codeId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/dac-codes"
			+ "?contestId=" + contestId
			+ "&codeId=" + codeId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putDacCodesStatus (context, contestId, status, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/dac-codes/status"
			+ "?contestId=" + contestId
			+ "&status=" + status
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, updateAgencyContestDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/data"
			, updateAgencyContestDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/finish"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putForm (context, defineSchemaDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/form"
			, defineSchemaDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFormStatus (context, statusDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/form-status"
			, statusDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putOpen (context, contestId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/open"
			+ "?contestId=" + contestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRatingParameter (context, param, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/rating-parameter"
			, param
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putRatingSettings (context, contestId, settings, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/rating-settings"
			+ "?contestId=" + contestId
			, settings
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putUser (context, contestId, userId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest/user"
			+ "?contestId=" + contestId
			+ "&userId=" + userId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
